import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        role: '='
    },
    template: `
        <div class="heading01 type01">
            <a ui-sref="authorized.user.group.list.role()" class="btn discrete" >{{ 'general.Back to list' | translate }}</a>
            <h1>{{ vm.role.value }}</h1>
        </div>
        <user-group-form-role form="vm.form" role="vm.role"/>
    `
})
export default class {
    constructor (FormFactory) {
        this.form = FormFactory.create(this.role, model => model.$update({ id: model.id }));
    }
}




// WEBPACK FOOTER //
// ./src/app/components/user/group/detail/role/index.js